import { render, staticRenderFns } from "./offcanvas.vue?vue&type=template&id=10fb9e10&"
import script from "./offcanvas.vue?vue&type=script&lang=js&"
export * from "./offcanvas.vue?vue&type=script&lang=js&"
import style0 from "./offcanvas.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports